import React, { useRef, useEffect, useState } from "react";
import "./Our_recommendation.css";
import Common_title from "../../common-components/common-title/Common_title";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import Frames_card from "../../common-components/common-card/frame-card/Frames_card";

const Our_recommendation = ({ products, product }) => {

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (swiperInstance) {
      const timer = setTimeout(() => {
        swiperInstance.update();
        swiperInstance.slideTo(0, 0);
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [swiperInstance]);

  
  useEffect(() => {
    if (
      swiperInstance &&
      !swiperInstance.destroyed &&
      prevRef.current &&
      nextRef.current
    ) {
      if (!swiperInstance.params.navigation) {
        swiperInstance.params.navigation = {};
      }
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;

      if (swiperInstance.navigation) {
        swiperInstance.navigation.destroy();
        swiperInstance.navigation.init();
        swiperInstance.navigation.update();
      }
    }
  }, [swiperInstance]);

  return (
    <>
      <section className="Our_recommendation_sec">

        <div className="reco_slider_outer">
          <button
            ref={prevRef}
            type="button"
            className="reco_nav_btn reco_nav_prev"
            aria-label="Previous"
          >
            <span>&#10094;</span>
          </button>

          <div className="reco_container">
            <div className="framesslider_sec">
              <Swiper
                onSwiper={setSwiperInstance}
                slidesPerView={1}
                centeredSlides={false}
                observer={true}
                observeParents={true}
                resizeObserver={true}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                onBeforeInit={(swiper) => {
                  // Attach the external buttons to Swiper before init,
                  // since refs aren't populated on the first render.
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                }}
                autoplay={{
                  delay: 2000000,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 5,
                  },
                  575: {
                    slidesPerView: 2.5,
                    spaceBetween: 5,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 5,
                  },
                  991: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  1200: {
                    slidesPerView: 5,
                    spaceBetween: 10,
                  },
                }}
                className="mySwiper"
                modules={[Autoplay, Navigation]}
              >
                {products?.data
                  ?.filter((item) => Number(item.id) !== Number(product?.id)) // ❌ remove matched product
                  .map((data, index) => (
                    <SwiperSlide key={index}>
                      <Frames_card
                        image={process.env.PUBLIC_URL + data.image}
                        type={data.type}
                        name={data.name}
                        id={data.id}
                        prise={data?.price || "N/A"}
                        oldprise={data?.mrp || "N/A"}
                      />
                    </SwiperSlide>
                  ))}
                  {/* {products?.data?.map((data, index) => (
                <SwiperSlide key={index}>
                  <Frames_card
                    image={process.env.PUBLIC_URL + data.image}
                    type={data.type}
                    name={data.name}
                    id={data.id}
                    prise={data?.price || "N/A"}
                    oldprise={data?.mrp || "N/A"}
                  />
                </SwiperSlide>
              ))} */}
              </Swiper>
            </div>
          </div>

          <button
            ref={nextRef}
            type="button"
            className="reco_nav_btn reco_nav_next"
            aria-label="Next"
          >
            <span>&#10095;</span>
          </button>
        </div>

        <div className="reco_title_wrap">
          <Common_title title={"Our "} titleblack={"recommendations"} />
        </div>
      </section>
    </>
  );
};

export default Our_recommendation;